import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "theme-uisidenav"
    }}>{`@theme-ui/sidenav`}</h1>
    <p>{`MDX-based sidebar navigation component`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm i @theme-ui/sidenav
`}</code></pre>
    <p>{`Given an MDX document like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-md"
      }}>{`- [Home](/)
- [About](/about)
- [Guides](/guides)
  - [Getting Started](/guides/getting-started)
  - [Gatsby](/guides/gatsby)
`}</code></pre>
    <p>{`The MDX document can be styled as a sidebar navigation component.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`/** @jsx jsx */
import { jsx } from 'theme-ui'
import { Sidenav } from '@theme-ui/sidenav'
import Links from './links.mdx'

export default props => (
  <Sidenav {...props}>
    <Links />
  </Sidenav>
)
`}</code></pre>
    <p>{`Alternatively, an accordion style sidenav can be rendered using the `}<inlineCode parentName="p">{`AccordionNav`}</inlineCode>{` component.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`/** @jsx jsx */
import { jsx } from 'theme-ui'
import { AccordionNav } from '@theme-ui/sidenav'
import Links from './links.mdx'

export default props => (
  <Links
    {...props}
    components={{
      wrapper: AccordionNav,
    }}
  />
)
`}</code></pre>
    <p>{`The same MDX document can be used to create pagination links.
Pass in the current `}<inlineCode parentName="p">{`pathname`}</inlineCode>{` to allow the `}<inlineCode parentName="p">{`Pagination`}</inlineCode>{` component to determine the previous and next links.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`/** @jsx jsx */
import { jsx } from 'theme-ui'
import { Pagination } from '@theme-ui/sidenav'
import { Location } from '@reach/router'
import Links from './links.mdx'

export default props =>
  <Location
    children={({ location }) => (
      <Links
        pathname={location.pathname}
        components={{
          wrapper: Pagination
        }}
      />
    )}
  />
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      